import Box, { type BoxProps } from '@mui/material/Box'

export default function FixedBox({ children, sx, ...rest }: BoxProps) {
    return (
        <Box
            sx={{
                ...sx,
                overflow: 'hidden',
                height: `calc(var(--app-height) - var(--app-toolbar-height) - var(--app-padding) * 2)`, // minus vertical padding
            }}
            {...rest}
        >
            {children}
        </Box>
    )
}
